<template>
  <div class="ah-search-bar">
    <form @submit="onSubmit">
      <visually-hidden>
        <label :for="id">
          {{ inputLabel }}
        </label>
      </visually-hidden>
      <input
        :id="id"
        class="ah-search-bar-input"
        type="text"
        :placeholder="inputPlaceholder"
        :value="value"
      />
      <button
        class="ah-search-bar-button"
        type="submit"
      >
        <visually-hidden>
          {{ buttonLabel }}
        </visually-hidden>
        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="9.85714" cy="9.85714" r="8.85714" stroke="black" stroke-width="2"/>
          <line x1="16.9928" y1="16.4357" x2="23.8499" y2="23.2929" stroke="black" stroke-width="2"/>
        </svg>
      </button>
    </form>
  </div>
</template>

<script>
  import VisuallyHidden from './shared/VisuallyHidden.vue'
  import { store } from '../data/store'

  export default {
    name: 'search-bar',
    props: {
      id: String,
      inputLabel: String,
      inputPlaceholder: String,
      buttonLabel: {
        type: String,
        default: 'Search',
      },
      onSubmit: Function,
    },
    computed: {
      value: function() {
        return store.searchParams
      },
    },
    components: {
        VisuallyHidden,
    },
  }
</script>

<style lang="scss" scoped>
  @import "../../scss/_variablesAH.scss";

  .ah-search-bar {
    position: relative;
    margin-bottom: 24px;
  }
  .ah-search-bar-input {
    height: 48px;
    border: solid 1px #AEAEBA;
    border-radius: 24px;
    font-size: 18px;
    font-family: $font-main;
    width: 100%;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 65px;
    -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
    -moz-box-sizing: border-box;    /* Firefox, other Gecko */
    box-sizing: border-box;         /* Opera/IE 8+ */
    outline: none;
  }
  .ah-search-bar-button {
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
    background: none;
    border: none;
    position: absolute;
    right: 8px;
    top: 0;
    cursor: pointer;
    outline: none;
  }
</style>